var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"supporting-file"},[_c('a',{attrs:{"href":_vm.downloadUrl}},[_c('i',{staticClass:"fas fa-fw fa-paperclip"}),_vm._v("\n        "+_vm._s(_vm.fileName)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }